(function () {
  'use strict';

  var modal   = document.getElementById('sfm-specs');
  if (!modal) return;

  var backdrop = modal.querySelector('.sfm__backdrop');
  var closeBtn = modal.querySelector('.sfm__close');

  function openModal() {
    modal.classList.add('is-visible');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });
  }

  function closeModal() {
    if (!modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (!modal.classList.contains('is-open')) modal.classList.remove('is-visible');
    }, 350);
  }

  if (backdrop) backdrop.addEventListener('click', closeModal);
  if (closeBtn) closeBtn.addEventListener('click', closeModal);

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && modal.classList.contains('is-open')) closeModal();
  });

  document.addEventListener('click', function (e) {
    var el = e.target;
    while (el && el !== document) {
      var href = el.getAttribute('href') || '';
      if (el.hasAttribute('data-open-specs-modal') || href === '#open-specs-modal') {
        e.preventDefault();
        openModal();
        return;
      }
      el = el.parentElement;
    }
  });

  /* Spec group accordion */
  Array.prototype.slice.call(modal.querySelectorAll('.sfm__spec-group-head')).forEach(function (head) {
    head.addEventListener('click', function () {
      var expanded = head.getAttribute('aria-expanded') === 'true';
      var body     = head.nextElementSibling;
      head.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (body && body.classList.contains('sfm__spec-group-body')) {
        body.classList.toggle('is-collapsed', expanded);
      }
    });
  });

})();
